import React, { useState } from 'react';
import { Button, Dropdown, Space } from 'antd';
import { useNarrowScreen } from '../hooks/useNarrowScreen';

type Props = {
  children: React.ReactNode;
  /** 桌面沿用的 Space 间距，默认与 antd Space 一致。 */
  size?: number | 'small' | 'middle' | 'large';
};

/** 窄屏把卡片右上角多个按钮收成「操作」。只有一个子节点时直接展示。 */
const NarrowExtra: React.FC<Props> = ({ children, size }) => {
  const narrow = useNarrowScreen();
  const [open, setOpen] = useState(false);
  const list = React.Children.toArray(children);

  if (!narrow) {
    return <Space size={size}>{children}</Space>;
  }
  if (list.length <= 1) {
    return <>{children}</>;
  }
  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      trigger={['click']}
      dropdownRender={() => (
        <div className="kfc-op-menu" onMouseDown={(e) => e.preventDefault()}>
          {list}
        </div>
      )}
    >
      <Button style={{ minHeight: 40 }}>操作</Button>
    </Dropdown>
  );
};

export default NarrowExtra;
